/* NAW facets v4 — flatten drawer, price slider, NA|FILTER header + close X */
(function () {
  window.__NAW_FACETS = 'v4';
  var LOGO = 'https://cdn.shopify.com/s/files/1/0810/4090/0375/files/na-mark-black-transparent.png?v=1782988318';

  function closeDrawer() {
    var summary = document.querySelector('.mobile-facets__disclosure > summary, summary.mobile-facets__open-wrapper');
    if (summary) summary.click();
  }

  function stripCounts(root) {
    if (!root) return;
    root.querySelectorAll('.mobile-facets__label').forEach(function (label) {
      var walker = document.createTreeWalker(label, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        var parent = node.parentElement;
        if (parent && parent.classList.contains('visually-hidden')) continue;
        if (/\(\d+/.test(node.textContent)) {
          node.textContent = node.textContent.replace(/\s*\(\d+[^)]*\)?\s*/g, ' ').replace(/\s+$/, '');
        }
      }
    });
  }

  function initDrawer() {
    var main = document.querySelector('.mobile-facets__main');
    if (!main) return;

    // 0) Hide any native close elements (button OR span) to avoid double X
    document.querySelectorAll('.mobile-facets__close, .mobile-facets__close--no-js').forEach(function (b) {
      if (!b.classList.contains('naw-drawer-close')) b.style.display = 'none';
    });

    // 1) Force the first two filter groups open
    var details = main.querySelectorAll(':scope > details.js-filter');
    for (var i = 0; i < details.length && i < 2; i++) {
      if (!details[i].hasAttribute('open')) details[i].setAttribute('open', '');
    }

    // 1b) Availability pills: strip "(count)"
    if (details[0]) stripCounts(details[0]);

    // 2) Price slider
    var lte = main.querySelector('input[name="filter.v.price.lte"]');
    var gte = main.querySelector('input[name="filter.v.price.gte"]');
    if (lte && !main.querySelector('.naw-price-slider')) {
      var top = Math.ceil(parseFloat(lte.max || lte.placeholder || '500'));
      var cur = lte.value ? Math.min(Math.ceil(parseFloat(lte.value)), top) : top;

      var wrap = document.createElement('div');
      wrap.className = 'naw-price-slider';
      wrap.innerHTML =
        '<div class="naw-price-slider__labels">' +
        '<span>£0</span>' +
        '<span class="naw-price-slider__value"></span>' +
        '<span>£' + top + '</span>' +
        '</div>' +
        '<input type="range" min="0" max="' + top + '" step="5" value="' + cur + '" aria-label="Maximum price">';

      var host = lte.closest('.mobile-facets__submenu') || lte.closest('details');
      if (host) host.insertBefore(wrap, host.firstChild);

      var range = wrap.querySelector('input[type="range"]');
      var valEl = wrap.querySelector('.naw-price-slider__value');
      var setLabel = function (v) {
        valEl.textContent = (parseInt(v, 10) >= top) ? 'ANY PRICE' : 'UP TO £' + v;
      };
      setLabel(cur);

      range.addEventListener('input', function () { setLabel(range.value); });
      range.addEventListener('change', function () {
        var v = parseInt(range.value, 10);
        lte.value = v >= top ? '' : v;
        if (gte) gte.value = '';
        lte.dispatchEvent(new Event('input', { bubbles: true }));
        lte.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    // 3) Cart-style header: NA | FILTER
    var headerInner = document.querySelector('.mobile-facets__inner .mobile-facets__header-inner');
    if (headerInner && !headerInner.querySelector('.naw-drawer-brand')) {
      var brand = document.createElement('div');
      brand.className = 'naw-drawer-brand';
      brand.innerHTML =
        '<img class="naw-drawer-brand__logo" src="' + LOGO + '" alt="Not Another">' +
        '<span class="naw-drawer-brand__divider"></span>' +
        '<span class="naw-drawer-brand__title">Filter</span>';
      headerInner.appendChild(brand);
    }

    // 4) Single guaranteed-visible close X
    var header = document.querySelector('.mobile-facets__inner .mobile-facets__header');
    if (header && !header.querySelector('.naw-drawer-close')) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'naw-drawer-close';
      btn.setAttribute('aria-label', 'Close filters');
      btn.textContent = String.fromCharCode(10005);
      btn.addEventListener('click', closeDrawer);
      header.appendChild(btn);
    }
  }

  // Keep the two groups un-collapsible
  document.addEventListener('click', function (e) {
    var summary = e.target.closest('.mobile-facets__main > details.js-filter > summary');
    if (!summary) return;
    var d = summary.parentElement;
    var siblings = Array.prototype.slice.call(d.parentElement.querySelectorAll(':scope > details.js-filter'));
    if (siblings.indexOf(d) < 2) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  function safeInit() {
    try { initDrawer(); } catch (e) { /* never break the page */ }
  }

  // Run now, on DOM ready, and keep self-healing (survives AJAX re-renders & rAF throttling)
  safeInit();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeInit);
  }
  window.addEventListener('load', safeInit);
  setInterval(safeInit, 1000);
})();